import { useState } from 'react';
import s from '../../styles/components/story/Gallery.module.css';

export default function Gallery({ data }) {
  const [hoveredCell, setHoveredCell] = useState(null);

  return (
    <div className={s.section}>
      <div className={s.grid}>
        {data.map((photo, i) => (
          <div
            key={i}
            className={`${s.cell} ${photo.size === 'large' ? s.cellLarge : ''}`}
            onMouseEnter={() => setHoveredCell(i)}
            onMouseLeave={() => setHoveredCell(null)}
          >
            <img
              src={photo.src}
              alt={photo.alt}
              className={`${s.image} ${hoveredCell === i ? s.imageHover : ''}`}
            />
            <div className={`${s.overlay} ${hoveredCell === i ? s.overlayActive : ''}`}>
              <span className={`${s.capLabel} ${hoveredCell === i ? s.capVisible : ''}`}>{photo.caption}</span>
              <span className={`${s.capBody} ${hoveredCell === i ? s.capVisible : ''}`}>{photo.captionBody}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}